import { v4 } from "uuid";
import Amplify, { API, graphqlOperation } from "aws-amplify";
import awsconfig from "../../aws-exports";
import { listCompetencias } from "../../graphql/queries";
import { detalleMisVoces, listCompetenciaDetalle, obtenerNombre, listVocesByTarget, listVocesTotalesByTarget, listVocesTotalesByOrigen } from "../../graphql/queries_custom";
import { apiSplunk } from "../../ApiLogicApp";

Amplify.configure(awsconfig);

let errorDynamo = "One or more parameter values are not valid. A value specified for a secondary index key is not supported."

export const obtenerCompetencias = async (id, userName, mail) => {
  try {
    if (id) {
      const filter = {
        "id": id
      };
      const apiData = await API.graphql(graphqlOperation(detalleMisVoces, filter));
      return await formarPills(apiData.data.getVoz.competenciaSolicitada);
    }
    else {
      const apiData = await API.graphql(graphqlOperation(listCompetencias))
      const competencias = apiData.data.listCompetencias.items;
      const competenciasList = [];

      for (let i = 0; i < competencias.length; i++) {
        competenciasList.push({
          id: v4(),
          title: competencias[i].nombre,
          category: competencias[i].categoria,
          type: competencias[i].tipo,
          desc: competencias[i].descripcion
        });
      }
      return competenciasList;
    }
  } catch (err) {
    await apiSplunk(userName, mail, err, true, 'Error obtenerCompetencias');
  }
}

// export const obtenerTips = async () => {
//   try {
//     const apiData = await API.graphql(graphqlOperation(tips))
//     const tips = apiData.data.tips.items;
//     return tips;
//   } catch (err) {
//     await apiSplunk(userName, mail, err, true, 'Error obtenerTips');
//   }
// }

export const vocesRecibidas = async (variables, userName, mail, items = []) => {
  try {
    const apiData = await API.graphql(graphqlOperation(listVocesByTarget, variables));
    const voces = apiData.data.listVocesByTarget;
    const newItems = [...items, ...voces.items];
    if (!voces.nextToken) {
      return newItems.length;
    }
    variables['nextToken'] = voces.nextToken;
    return vocesRecibidas(variables, userName, mail, newItems);
  } catch (err) {
    if (!err.errors[0].message.includes(errorDynamo))
      await apiSplunk(userName, mail, err, true, 'Error vocesRecibidas');
  }
}

export const vocesTotalesByTarget = async (variables, userName, mail, items = []) => {
  try {
    const apiData = await API.graphql(graphqlOperation(listVocesTotalesByTarget, variables));
    const vocesListTotal = apiData.data.listVocesByTarget;
    const newItems = [...items, ...vocesListTotal.items];
    if (!vocesListTotal.nextToken) {
      return newItems;
    }
    variables['nextToken'] = vocesListTotal.nextToken;
    return vocesTotalesByTarget(variables, userName, mail, newItems);

  } catch (err) {
    if (!err.errors[0].message.includes(errorDynamo))
      await apiSplunk(userName, mail, err, true, 'Error vocesTotalesByTarget');
  }
}

export const vocesTotalesByOrigen = async (variables, userName, mail, items = []) => {
  try {
    const apiData = await API.graphql(graphqlOperation(listVocesTotalesByOrigen, variables));
    const vocesListTotal = apiData.data.listVocesByOrigen;
    const newItems = [...items, ...vocesListTotal.items];
    if (!vocesListTotal.nextToken) {
      return newItems;
    }
    variables['nextToken'] = vocesListTotal.nextToken;
    return vocesTotalesByOrigen(variables, userName, mail, newItems);

  } catch (err) {
    await apiSplunk(userName, mail, err, true, 'Error vocesTotalesByOrigen');
  }
}

export const getUserById = async (variables, userName, mail) => {
  try {
    const apiData = await API.graphql(graphqlOperation(obtenerNombre, variables));
    const vozListInfo = apiData.data.getVoz;
    return vozListInfo;
  } catch (err) {
    await apiSplunk(userName, mail, err, true, 'Error getUserById');
  }
}

export const detalleVoz = async (variables, userName, mail) => {
  let arrayExcelente = [];
  let arrayBueno = [];
  let arrayMejorar = [];
  let arrayAdecuado = [];
  try {
    const apiData = await API.graphql(graphqlOperation(detalleMisVoces, variables));
    const vozListInfo = apiData.data.getVoz;
    if (vozListInfo.competenciaExcelente)
      arrayExcelente = await formarPills(vozListInfo.competenciaExcelente, userName, mail);
    if (vozListInfo.competenciaBueno)
      arrayBueno = await formarPills(vozListInfo.competenciaBueno, userName, mail);
    if (vozListInfo.competenciaAdecuado)
      arrayAdecuado = await formarPills(vozListInfo.competenciaAdecuado, userName, mail);
    if (vozListInfo.competenciaMejorar)
      arrayMejorar = await formarPills(vozListInfo.competenciaMejorar, userName, mail);
    let variable = {
      competenciaExcelente: arrayExcelente,
      competenciaBueno: arrayBueno,
      competenciaAdecuado: arrayAdecuado,
      competenciaMejorar: arrayMejorar,
      origenName: apiData.data.getVoz.origenName,
      targetName: apiData.data.getVoz.targetName,
      email: apiData.data.getVoz.origen,
      emailTarget: apiData.data.getVoz.target,
      comentario: vozListInfo.comentario,
      anexos: vozListInfo.anexos,
      conversacion: vozListInfo.conversacion
    };
    return variable;
  } catch (err) {
    await apiSplunk(userName, mail, err, true, 'Error detalleVoz');
  }
}

const formarPills = async (vozListInfo, userName, mail) => {
  const array = [];
  for (let i = 0; i < vozListInfo.length; i++) {
    let filter = {
      filter: {
        "and": [
          {
            "nombre": { "eq": vozListInfo[i] }
          }
        ]
      }
    };
    let descripcion = await competenciaDescripcion(filter, userName, mail);
    array.push({
      id: v4(),
      title: descripcion.nombre,
      category: descripcion.categoria,
      type: descripcion.tipo,
      desc: descripcion.descripcion
    });
  }
  return array;
}

const competenciaDescripcion = async (variables, userName, mail) => {
  try {
    const apiData = await API.graphql(graphqlOperation(listCompetenciaDetalle, variables));
    return apiData.data.listCompetencias.items[0];
  } catch (err) {
    await apiSplunk(userName, mail, err, true, 'Error competenciaDescripcion');
  }
}

const competenciasConsulta = async (variables, userName, mail, items = []) => {
  try {
    const apiData = await API.graphql(graphqlOperation(listVocesByTarget, variables));
    const voces = apiData.data.listVocesByTarget;
    const newItems = [...items, ...voces.items];
    if (!voces.nextToken) {
      return newItems;
    }
    variables['nextToken'] = voces.nextToken;
    return await competenciasConsulta(variables, userName, mail, newItems);
  } catch (err) {
    await apiSplunk(userName, mail, err, true, 'ErrorcompetenciasConsulta');
  }
}

export const competenciasFuertes = async (competencias, abilitiesArray) => {
  const orden = { "m1": { "key": "", "value": 0 }, "m2": { "key": "", "value": 0 }, "m3": { "key": "", "value": 0 }, "m4": { "key": "", "value": 0 } };

  let totalSumaCompetencias = 0;
  let jsonToArray = Object.entries(competencias.totalCompetenciasOrden).filter(([key]) => !abilitiesArray.includes(key));
  const total = Object.fromEntries(jsonToArray);
  const array = [];
  for (const clave in total) {
    array.push({
      clave: clave,
      valor: total[clave]
    });
  }
  array.sort(function (a, b) {
    if (a.valor > b.valor) return -1;
    if (a.valor < b.valor) return 1;
    return 0;
  });

  let i = 0;
  for (const item of array) {
    if (i < 4 && item != null)
      totalSumaCompetencias += item.valor;
    i++;
  }
  if (array[0] != null) {
    orden.m1.key = array[0].clave;
    orden.m1.value = Math.round((array[0].valor / totalSumaCompetencias) * 100);
  }
  if (array[1] != null) {
    orden.m2.key = array[1].clave;
    orden.m2.value = Math.round((array[1].valor / totalSumaCompetencias) * 100);
  }
  if (array[2] != null) {
    orden.m3.key = array[2].clave;
    orden.m3.value = Math.round((array[2].valor / totalSumaCompetencias) * 100);
  }
  if (array[3] != null) {
    orden.m4.key = array[3].clave;
    orden.m4.value = Math.round((array[3].valor / totalSumaCompetencias) * 100);
  }
  return orden;
};

// Cada categoría de competencia de una voz se acumula en una columna distinta del gráfico.
// El orden de esta lista es el orden en que se procesan las categorías.
const PESO_COMPETENCIA = 1;
const CATEGORIAS_COMPETENCIA = [
  { campo: "competenciaExcelente", contador: "excelente", columna: "maleyoung", peso: PESO_COMPETENCIA },
  { campo: "competenciaBueno", contador: "bueno", columna: "malemiddle", peso: PESO_COMPETENCIA },
  { campo: "competenciaAdecuado", contador: "adecuado", columna: "malehalf", peso: PESO_COMPETENCIA },
  { campo: "competenciaMejorar", contador: "mejorar", columna: "maleolder", peso: PESO_COMPETENCIA }
];

const crearEntradaCategoria = (estado, columna, peso) => ({
  state: estado,
  maleyoung: 0,
  malemiddle: 0,
  malehalf: 0,
  maleolder: 0,
  [columna]: peso
});

// Se conserva el operador `in` del código original: también considera propiedades heredadas.
const acumularCategoria = (voz, categoria, acumulado, skillArray) => {
  const { campo, contador, columna, peso } = categoria;
  const { total, totalCompetenciaCategoria, totalCompetenciasLongitud } = acumulado;
  const competenciasDeLaVoz = voz[campo];
  if (!competenciasDeLaVoz) return;

  for (const competencia of competenciasDeLaVoz) {
    if (!skillArray.includes(competencia))
      totalCompetenciasLongitud[contador] += 1;
    if (competencia in total) {
      total[competencia] += peso;
      totalCompetenciaCategoria.forEach(function (entrada) {
        if (entrada.state === competencia) {
          entrada[columna] += peso;
        }
      });
    }
    else {
      total[competencia] = peso;
      totalCompetenciaCategoria.push(crearEntradaCategoria(competencia, columna, peso));
    }
  }
};

const puntajeCategoria = (c) =>
  c.maleyoung * 10 + c.malemiddle * 5 + c.maleolder + c.malehalf * 2 - c.malemiddle * 6 - c.maleolder * 3;

const compararPorPuntaje = (a, b) => {
  const sumA = puntajeCategoria(a);
  const sumB = puntajeCategoria(b);
  if (sumA > sumB) return -1;
  if (sumA < sumB) return 1;
  return 0;
};

export const competenciasGraph = async (variables, userName, mail, skillArray) => {
  const array = await competenciasConsulta(variables, userName, mail);
  const acumulado = {
    total: {},
    totalCompetenciaCategoria: [],
    totalCompetenciasLongitud: { "excelente": 0, "bueno": 0, "mejorar": 0, "adecuado": 0 }
  };
  array.forEach(function (voz) {
    CATEGORIAS_COMPETENCIA.forEach(function (categoria) {
      acumularCategoria(voz, categoria, acumulado, skillArray);
    });
  });
  acumulado.totalCompetenciaCategoria.sort(compararPorPuntaje);

  return {
    "totalCompetenciaCategoria": acumulado.totalCompetenciaCategoria,
    "totalCompetenciasLongitud": acumulado.totalCompetenciasLongitud,
    "totalCompetenciasOrden": acumulado.total
  };
};
